import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';

const useRealizedPerformanceFeesToDate = () => {
    const { interfaceSDK } = useContext(appContext);

    const { data, error } = useSWR(
        interfaceSDK ? 'realizedPerformanceFeesToDate' : null,
        () => interfaceSDK!.get.getRealizedPlatformPerformanceFees()
    );

    return {
        realizedPerformanceFeesToDate: data,
        isLoading: !error && !data,
        error,
    };
};

export default useRealizedPerformanceFeesToDate;
